import { Skeleton } from '@frontend-workspace/react-shared-lib';

export function LicensesGridSkeleton() {
  return (<>
    <div className='d-flex justify-content-end'>
      <Skeleton animation="wave" width={150} height={50} />
    </div>

    <Skeleton variant="rectangular" animation="wave" width='100%' height={1100} />

    <div className='d-flex justify-content-end'>
      <Skeleton animation="wave" width={150} height={50} />
    </div>
  </>);
}

export default LicensesGridSkeleton;
